export let summary = 'A Skilled full stack developer and quick learner who can quickly adapt to new environments. Great Team Player with ability of problem solving. Currently, I love to work on web application using technologies like Javascript, React, Chakra UI, Material UI, Node JS, Express, Mongo DB and Firebase.';
export let name = 'Ritik Kumar Singh';
export let image = 'https://firebasestorage.googleapis.com/v0/b/collection-mart.appspot.com/o/DSC_3315-removebg.png?alt=media&token=e5843f3b-47b1-4571-8e3b-66c4e456e63f'

export const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    img: "https://firebasestorage.googleapis.com/v0/b/collection-mart.appspot.com/o/Screenshot%20(664).png?alt=media&token=0c058c18-d76d-42e6-9765-2f98ad7a69a7",
    name: 'RelaxBuddy (Individual Project)',
    description:
      "RelaxBuddy is a multi-user music streaming web app, where you can listen your favorite songs, premium songs and many more.",
    stack: ['React', 'JavaScript', 'Mongo Db', 'Node JS', 'Express', 'Firebase Storage'],
    sourceCode: 'https://github.com/Ritik73011/RelaxBuddy',
    livePreview: 'https://relax-buddy.netlify.app/',
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/collection-mart.appspot.com/o/Screenshot%20(562).png?alt=media&token=6fb34989-0f00-4af3-9618-e5f637812a25",
    name: 'MasaiKart',
    description:
      "MasaiKart is an e-commerce web application where user can buy various products like, cloths, shoes , slippers , electronics products, mobiles , accessories, furniture and etc. ",
    stack: ['HTML', 'CSS', 'JavaScript', 'Firebase'],
    sourceCode: 'https://github.com/Ritik73011/Masai-Kart',
    livePreview: 'https://prismatic-rugelach-a9bce4.netlify.app/',
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/collection-mart.appspot.com/o/Screenshot%20(564).png?alt=media&token=bfade140-504f-4681-93b2-d841972531d6",
    name: 'Mahabis.com (Clone)',
    description:
      'Mahabis.com clone an e-commerce web application that allows you to buy different range of shoes which are made with natural rubbers.',
    stack: ['JavaScript', 'Chakra UI', 'React', 'Redux', "Firebase Auth"],
    sourceCode: 'https://github.com/Md-Alqma/mahabis-clone',
    livePreview: 'https://dreamy-frangipane-645120.netlify.app/',
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/collection-mart.appspot.com/o/Screenshot%20(662).png?alt=media&token=2d49ce53-636b-41ea-8c87-ea7b40ec288d",
    name: 'Blissworld (Clone)',
    description:
      'Blissworld is e-commerce website offers products related to body & hair care. We clone this website for learning purpose. We developed this website use React, Redux , Express, Mongo DB, Node JS & Chakra-UI',
    stack: ['JavaScript', 'Chakra UI', 'React', "Mongo DB", "Express", "Node JS"],
    sourceCode: 'https://github.com/Ritik73011/Bliss_World_Full_Stack_Clone',
    livePreview: 'https://blissworld-fullstack-clone.netlify.app/',
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/collection-mart.appspot.com/o/Screenshot%20(399).png?alt=media&token=95c096ce-5b81-4618-83df-19844438c6a0",
    name: 'Netmeds.com (Clone)',
    description:
      'Netmeds.com is a trusted Indian online pharmacy where user can buy a different types of medicines. It provides various services such as medicines, healthcare facilities, healthcare products, etc.',
    stack: ['HTML', 'CSS', 'Javascript'],
    sourceCode: 'https://github.com/Ritik73011/Netmeds-Clone',
    livePreview: 'https://beautiful-donut-393183.netlify.app/',
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/collection-mart.appspot.com/o/Screenshot%20(641).png?alt=media&token=50dd8a5a-8e3e-41c4-a9c9-98c9e407462f",
    name: 'YouTube (Clone)',
    description:
      'This is the clone of YouTube where user see the popular videos in homepage and also user can search the videos and user can also able to watch the videos.',
    stack: ['HTML', 'CSS', 'Javascript'],
    sourceCode: 'https://github.com/Ritik73011/YouTube-Clone',
    livePreview: 'https://beautiful-bublanina-4e6c6a.netlify.app/',
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/collection-mart.appspot.com/o/Screenshot%20(642).png?alt=media&token=16592f27-0601-4bcb-beec-ed7963a9d50c",
    name: 'Weather App',
    description:
      'This is the Weather App where users can see the weather of current location and search the location and also able to see the weather of next 7 days.',
    stack: ['HTML', 'CSS', 'Javascript'],
    sourceCode: 'https://github.com/Ritik73011/Weather-App',
    livePreview: 'https://thriving-tartufo-e21443.netlify.app/',
  }
]

export const skillList = [
  {
    title: "HTML",
    logo: "https://mohitkss.github.io/static/media/html5.4e6edfe05f07c383e94f.png",
  },
  {
    title: "CSS",
    logo: "https://mohitkss.github.io/static/media/css3.845e8eb63836bef093cf.png",
  },
  {
    title: "JavaScript",
    logo: "https://mohitkss.github.io/static/media/js.3dfb665e058d08c99f28.png",
  },
  {
    title: "React",
    logo: "https://mohitkss.github.io/static/media/react.22d1f2096ed82cab7a8a.png",
  },
  {
    title: "Redux",
    logo: "https://mohitkss.github.io/static/media/redux.7fec6369cecd1cbd44d6.png",
  },
  {
    title: "Node JS",
    logo: "https://mohitkss.github.io/static/media/nodejs.b508473ad71a31ce2fae.png",
  },
  {
    title: "Mongo DB",
    logo: "https://mohitkss.github.io/static/media/mongodb.4f7af09e6354d51beec8.png",
  },
  {
    title: "Chakra UI",
    logo: "https://avatars.githubusercontent.com/u/54212428?s=280&v=4",
  },
  {
    title: "Material UI",
    logo: "https://mui.com/static/logo.png",
  },
  {
    title: "Git",
    logo: "https://mohitkss.github.io/static/media/git.b1472a80b81e487179cf.png",
  },
  {
    title: "Github",
    logo: "https://cdn-icons-png.flaticon.com/512/25/25231.png",
  },
  {
    title: "ExpressJS",
    logo: "https://assets.website-files.com/61ca3f775a79ec5f87fcf937/6202fcdee5ee8636a145a41b_1234.png",
  },
  {
    title: "Firebase",
    logo: "https://logodix.com/logo/1858340.png",
  },
  {
    title: "Core Java",
    logo: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  }
];